import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreConfigurationService } from '../../../services/store-configuration/store-configuration.service';
import { StoreConfiguration } from '../../../models/store-configuration.model';
import { TranslateService } from '@ngx-translate/core/';
import { FrontEndService } from '../../../services/front-end/front-end.service';
import { PromotionSystemService } from '../../../services/promotion-system/promotion-system.service';
import { CustomerSystemService } from '../../../services/customer-system/customer-system.service';
import { LoyaltySystemService } from '../../../services/loyalty-system/loyalty-system.service';
import { AnalyticsSystemService } from '../../../services/analytics-system/analytics-system.service';
import { BackofficeSystemService } from '../../../services/backoffice-system/backoffice-system.service';
import { CouponingSystemService } from '../../../services/couponing-system/couponing-system.service';
import { PromotionOchannelService } from '../../../services/promotion/promotion-ochannel.service';

@Component({
  selector: 'app-store-configuration',
  templateUrl: './store-configuration.component.html',
  styleUrls: ['./store-configuration.component.css'],
  providers: []
})
export class StoreConfigurationComponent implements OnInit {

  newDataAvailable = false;

  showViewDialog = false;
  viewRow: any = null;

  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;
  selectFilter = KontableComponent.SelectFilter;

  statusOptions: Array<{ label: string, value: string }> = [];
  frontEndOptions: Array<{ label: string, value: string }> = [{ label: '', value: '' }];
  promotionOptions: Array<{ label: string, value: string }> = [{ label: '', value: '' }];
  customerOptions: Array<{ label: string, value: string }> = [{ label: '', value: '' }];
  loyaltyOptions: Array<{ label: string, value: string }> = [{ label: '', value: '' }];
  analyticsOptions: Array<{ label: string, value: string }> = [{ label: '', value: '' }];
  backofficeOptions: Array<{ label: string, value: string }> = [{ label: '', value: '' }];
  couponingOptions: Array<{ label: string, value: string }> = [{ label: '', value: '' }];
  channelOptions: Array<{ label: string, value: string }> = [{ label: '', value: '' }];

  constructor(
    public srvStoreConfiguration: StoreConfigurationService,
    private srvTranslate: TranslateService,
    private router: Router,
    private srvFrontEnd: FrontEndService,
    private srvPromotion: PromotionSystemService,
    private srvCustomer: CustomerSystemService,
    private srvLoyalty: LoyaltySystemService,
    private srvAnalytics: AnalyticsSystemService,
    private srvBackoffice: BackofficeSystemService,
    private srvCouponing: CouponingSystemService,
    private srvOchannel: PromotionOchannelService
  ) { }

  ngOnInit() {
    this.srvTranslate.get(['status.active', 'status.expired', 'status.future']).subscribe(translations => {
      this.statusOptions.length = 0;
      this.statusOptions.push(
        { label: '', value: '' },
        { label: translations['status.active'], value: 'ACTIVE' },
        { label: translations['status.expired'], value: 'EXPIRED' },
        { label: translations['status.future'], value: 'FUTURE' }
      );
    });

    this.loadFilterOptions();
  }

  private fillOptions(target: Array<{ label: string, value: string }>, items: any[]) {
    target.length = 0;
    target.push({ label: '', value: '' });
    for (const item of items || []) {
      if (item && item.name) {
        target.push({ label: item.name, value: item.name });
      }
    }
  }

  loadFilterOptions() {
    this.srvFrontEnd.getAll().subscribe(res => this.fillOptions(this.frontEndOptions, res));
    this.srvPromotion.getAll().subscribe(res => this.fillOptions(this.promotionOptions, res));
    this.srvCustomer.getAll().subscribe(res => this.fillOptions(this.customerOptions, res));
    this.srvLoyalty.getAll().subscribe(res => this.fillOptions(this.loyaltyOptions, res));
    this.srvAnalytics.getAll().subscribe(res => this.fillOptions(this.analyticsOptions, res));
    this.srvBackoffice.getAll().subscribe(res => this.fillOptions(this.backofficeOptions, res));
    this.srvCouponing.getAll().subscribe(res => this.fillOptions(this.couponingOptions, res));
    this.srvOchannel.list().subscribe((res: any) => {
      this.channelOptions.length = 0;
      this.channelOptions.push({ label: '', value: '' });
      for (const item of res || []) {
        if (item && item.code) {
          this.channelOptions.push({ label: item.code, value: item.code });
        }
      }
    });
  }

  refresh() {
    this.newDataAvailable = true;
  }

  showAddOrEditDialog(data): void {
    if (data == null) {
      this.router.navigate(['/division-sales-network-configuration/form']);
    } else {
      this.router.navigate(['/division-sales-network-configuration/form', data.id]);
    }
  }

  deleteItem(record): void {
    this.srvStoreConfiguration.delete(record).subscribe(() => {
      this.refresh();
    });
  }

  viewItem(row): void {
    this.viewRow = row;
    this.showViewDialog = true;
  }

  closeViewDialog(): void {
    this.showViewDialog = false;
    this.viewRow = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store-configuration/store-configuration.component.ts